module.exports = __webpack_public_path__ + "media/images/celmi-b161dc5e177e05b235105d0b801d9d42.png";